export const isNullOrUndefined = (value: string | boolean | number) => {
    return value ? value: null;
}

export const replaceStarWithComma = (value: string) => {
  return value ? value.replaceAll('*', ',') : null;
}

export const deleteRowData  = (records: any, rowId: string, dataToCompare: string | number | boolean) => {
  const index = records.findIndex((item: any) => item[rowId] == dataToCompare);
  if(index != -1 ){
    return records.splice(index,1)
  } 
  return records
}
